import { StorageEvent } from '../event';
import { NoTableInfoError } from '../error';
import Model from './model';
var ModelManager = /** @class */ (function () {
    function ModelManager(eventBus) {
        this.models = [];
        this.eventBus = eventBus;
    }
    ModelManager.prototype.register = function (modelClass) {
        if (this.models.includes(modelClass)) {
            return;
        }
        var schema = this.getSchema(modelClass);
        this.models.push(modelClass);
        this.eventBus.emit(StorageEvent.RegisterModel, { class: modelClass, schema: schema });
    };
    ModelManager.prototype.getSchema = function (modelClass) {
        var schema = Model.revealSchema(modelClass);
        if (!schema) {
            var error = new NoTableInfoError(modelClass.name);
            this.eventBus.emit(StorageEvent.Error, error);
            throw new NoTableInfoError(modelClass.name);
        }
        return schema;
    };
    ModelManager.prototype.getSchemaAndRegisterModelIfNeed = function (modelClass) {
        this.register(modelClass);
        return this.getSchema(modelClass);
    };
    return ModelManager;
}());
export default ModelManager;
//# sourceMappingURL=model-manager.js.map